import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import _ from "lodash";

class SalesInformation extends Component {
  render() {
    const { data } = this.props;
    let salesProfile, salesBranch;
    if (data) {
      const { Booking } = data;
      if (Booking) {
        salesProfile = Booking.SalesProfile;
        if (salesProfile) {
          salesBranch = salesProfile.SalesBranch;
        }
      }
    }
    return (
      <Col xs={24} md={12}>
        <Card title="Sales Information">
          <Form.Item label="Nama Sales">
            <span className="ant-form-text form-text-mod">
              {salesProfile ? salesProfile.name : null}
            </span>
          </Form.Item>
          <Form.Item label="Cabang">
            <span className="ant-form-text form-text-mod">
              {salesBranch ? salesBranch.branch : null}
            </span>
          </Form.Item>
          <Form.Item label="No. Hp">
            <span className="ant-form-text form-text-mod">
              {salesProfile ? salesProfile.phone : null}
            </span>
          </Form.Item>
        </Card>
      </Col>
    );
  }
}

export default SalesInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/SalesInformation.js